module.exports = "<p>\n  dashboard works!\n</p>\n\n"


//////////////////
// WEBPACK FOOTER
// /workspace/chess.arska.org/chess/src/app/dashboard/dashboard.component.html
// module id = ../../../../../src/app/dashboard/dashboard.component.html
// module chunks = main